export const RECIPES = [
  {
    "title": "Almond Chicken Skewers with Green Beans",
    "url": "http://drhyman.com/blogs/content/almond-chicken-skewers-with-green-beans",
    "image": "//drhyman.com/cdn/shop/articles/mkblog.png?v=1753044461&width=433",
  },  {
    "title": "Pico de Gallo and Guacamole",
    "url": "http://drhyman.com/blogs/content/pico-de-gallo-guacamole",
    "image": "//drhyman.com/cdn/shop/articles/newblogmk.png?v=1752948157&width=433",
  },
  {
    "title": "Zesty Carrot Fries",
    "url": "http://drhyman.com/blogs/content/zesty-carrot-fries",
    "image": "//drhyman.com/cdn/shop/articles/carrot_fries_30676e0f-abcf-4484-8aef-edb92e037731.png?v=1752182583&width=433",
  },
  {
    "title": "Strawberry Ginger Smoothie",
    "url": "http://drhyman.com/blogs/content/strawberry-ginger-smoothie",
    "image": "//drhyman.com/cdn/shop/articles/straw.png?v=1751389118&width=433",
  },
  {
    "title": "Creamy Ranch Dressing",
    "url": "http://drhyman.com/blogs/content/creamy-ranch-dressing",
    "image": "//drhyman.com/cdn/shop/articles/ranch.png?v=1750275668&width=433",
  },  {
    "title": "Inside-Out Burgers",
    "url": "http://drhyman.com/blogs/content/inside-out-burgers",
    "image": "//drhyman.com/cdn/shop/articles/u9994618697_45-degree_angle_shot_of_a_burger_patty_sandwiched_b_3cb81f2a-d44a-4d9e-9590-319314f13502.png?v=1751041125&width=433",
  },
  {
    "title": "Miso-Glazed Salmon  with Cilantro Cauliflower Rice",
    "url": "http://drhyman.com/blogs/content/miso-glazed-salmon-with-cilantro-cauliflower-rice",
    "image": "//drhyman.com/cdn/shop/articles/salmoncaulirice_1.jpg?v=1750280320&width=433",
  },
  {
    "title": "Avocado Stuffed with Creamy Chicken Salad",
    "url": "http://drhyman.com/blogs/content/avocado-stuffed-with-creamy-chicken-salad",
    "image": "//drhyman.com/cdn/shop/articles/avafinalv1_67938ca4-e51f-49ec-8b07-12229c09f500.jpg?v=1750090639&width=433",
  },
  {
    "title": "Coconut Chia Pudding",
    "url": "http://drhyman.com/blogs/content/coconut-chia-pudding",
    "image": "//drhyman.com/cdn/shop/articles/blogchia.jpg?v=1749248784&width=433",
  },
  {
    "title": "Garam Masala Seared Scallops",
    "url": "http://drhyman.com/blogs/content/garam-masala-seared-scallops",
    "image": "//drhyman.com/cdn/shop/articles/u9994618697_Garam_masala-seared_scallops_with_a_golden_crust_to_1_aa6d5865-749d-41c6-a48b-308f9bdfbeb2.png?v=1748891806&width=433",
  },
  {
    "title": "Chimichurri Sauce (Put it on everything!)",
    "url": "http://drhyman.com/blogs/content/chimichurri-sauce-put-it-on-everything",
    "image": "//drhyman.com/cdn/shop/articles/chimmi_50fa3d4b-3340-4200-bdb0-a1a208dd0507.jpg?v=1748017856&width=433",
  },
  {
    "title": "Morning Glory Muffins",
    "url": "http://drhyman.com/blogs/content/morning-glory-muffins",
    "image": "//drhyman.com/cdn/shop/articles/muffinMK.jpg?v=1747336304&width=433",
  },
  {
    "title": "Mom's Poached Fish in Velvety Tomato Sauce",
    "url": "http://drhyman.com/blogs/content/moms-poached-fish-in-velvety-tomato-sauce",
    "image": "//drhyman.com/cdn/shop/articles/img.jpg?v=1747088482&width=433",
  },  {
    "title": "Spicy Green Super Smoothie",
    "url": "http://drhyman.com/blogs/content/spicy-green-super-smoothie",
    "image": "//drhyman.com/cdn/shop/articles/smooth_1b7faf04-4c00-4f5d-904b-c2af90d9c412.jpg?v=1746126642&width=433",
  },
  {
    "title": "Quick Chicken Breast with Spanish Romesco Sauce",
    "url": "http://drhyman.com/blogs/content/quick-chicken-breast-with-spanish-romesco-sauce",
    "image": "//drhyman.com/cdn/shop/articles/u9994618697_A_top-down_view_of_sliced_chicken_breasts_served_wi_b2e2e820-d959-4cfa-a2e4-1a03eba3a5c6.png?v=1745600169&width=433",
  },
  {
    "title": "Jicama Hash",
    "url": "http://drhyman.com/blogs/content/jicama-hash",
    "image": "//drhyman.com/cdn/shop/articles/u9994618697_Top-down_view_of_a_single_white_bowl_on_a_white_mar_e4c731b5-8a52-46af-9636-675f319c8923.png?v=1745243901&width=433",
  },
  {
    "title": "Garlic Butter Steak with Sautéed Mushrooms & Brussels Sprouts",
    "url": "http://drhyman.com/blogs/content/garlic-butter-steak-with-sauteed-mushrooms-brussels-sprouts",
    "image": "//drhyman.com/cdn/shop/articles/steak_5f639ed7-ac4b-4645-adf0-485fe909c919.jpg?v=1745021416&width=433",
  },
  {
    "title": "Asian-Inspired Chicken & Veggie Bowl",
    "url": "http://drhyman.com/blogs/content/asian-inspired-chicken-veggie-bowl",
    "image": "//drhyman.com/cdn/shop/articles/u9994618697_Side_or_45-degree_angle_view_of_an_Asian-inspired_c_f6a58ee6-9a6d-4a0e-94c0-7a0ee2610c4e.png?v=1744054503&width=433",
  },
  {
    "title": "Caesar Salad with Grilled Chicken",
    "url": "http://drhyman.com/blogs/content/caesar-salad-with-grilled-chicken",
    "image": "//drhyman.com/cdn/shop/articles/u9994618697_A_vibrant_Caesar_salad_with_bite-sized_torn_romaine_84bb419f-a8fd-4b09-8149-25632c57a6bb.png?v=1743460733&width=433",
  },
  {
    "title": "Spicy Turkey & Avocado Lettuce Wraps",
    "url": "http://drhyman.com/blogs/content/spicy-turkey-avocado-lettuce-wraps",
    "image": "//drhyman.com/cdn/shop/articles/09_turkeywraps.jpg?v=1742862245&width=433",
  },
  {
    "title": "Garlic Shrimp with Sautéed Greens & Cauliflower Rice",
    "url": "http://drhyman.com/blogs/content/garlic-shrimp-with-sauteed-greens-cauliflower-rice",
    "image": "//drhyman.com/cdn/shop/articles/06_garlicshrimp.jpg?v=1742226900&width=433",
  },
  {
    "title": "Easy Crockpot Shredded Chicken",
    "url": "http://drhyman.com/blogs/content/easy-crockpot-shredded-chicken",
    "image": "//drhyman.com/cdn/shop/articles/chxxrock.png?v=1741620186&width=433",
  },
  {
    "title": "Lemon Raspberry Muffin",
    "url": "http://drhyman.com/blogs/content/lemon-raspberry-muffin",
    "image": "//drhyman.com/cdn/shop/articles/u9994618697_A_batch_of_warm_golden-brown_rasberry_muffins_with__9ec805a8-9d5d-421c-ae08-ba82d0d1e5b5.png?v=1741037694&width=433",
  },
  {
    "title": "Baked Salmon Cakes",
    "url": "http://drhyman.com/blogs/content/baked-salmon-cakes",
    "image": "//drhyman.com/cdn/shop/articles/u9994618697_Two_large_golden_brown_lightly_crispy_salmon_cake_a72680bb-8086-4f1f-a7b5-9a13b61d137d_2.png?v=1740431989&width=433",
  },
  {
    "title": "Southwest Salad",
    "url": "http://drhyman.com/blogs/content/southwest-salad",
    "image": "//drhyman.com/cdn/shop/articles/swsalad_6305bbe7-83b6-4628-8d59-20a125e5182c.jpg?v=1739833895&width=433",
  },
  {
    "title": "Shrimp & Broccoli with Lemon",
    "url": "http://drhyman.com/blogs/content/shrimp-broccoli-with-lemon",
    "image": "//drhyman.com/cdn/shop/articles/u9994618697_broccoli_florets_large_peeled_and_deveined_shrimp_r_2114639c-2fcb-4089-b7dd-1c3a5babf127.png?v=1739243887&width=433",
  },
  {
    "title": "Frittata with Spinach, Zucchini, Onion and Fresh Herbs",
    "url": "http://drhyman.com/blogs/content/frittata-with-spinach-zucchini-onion-and-fresh-herbs",
    "image": "//drhyman.com/cdn/shop/articles/frittata.png?v=1738108965&width=433",
  },
  {
    "title": "Steak and Veggie Bowl",
    "url": "http://drhyman.com/blogs/content/steak-and-veggie-bowl",
    "image": "//drhyman.com/cdn/shop/articles/steak_salad_d2e79560-04bc-4246-bca3-5c154c5752c4.png?v=1738108820&width=433",
  },
  {
    "title": "Lamb Meatballs with Tomato-Cucumber Salad and Cashew Yogurt",
    "url": "http://drhyman.com/blogs/content/lamb-meatballs-with-tomato-cucumber-salad-and-cashew-yogurt",
    "image": "//drhyman.com/cdn/shop/articles/lamb_meatballs_1_531f3cc8-935e-4752-95b4-f6a5b9df5cce.png?v=1739243890&width=433",
  },
  {
    "title": "Salmon Salad & Cucumber Scoops with Tahini Dressing",
    "url": "http://drhyman.com/blogs/content/salmon-salad-cucumber-scoops-with-tahini-dressing",
    "image": "//drhyman.com/cdn/shop/articles/cucumber_salad_520x500_520x500_520x500_87572fa4-0c60-48f2-9266-21c498cecb67.png?v=1736529406&width=433",
  },
  {
    "title": "Cranberry Moscow Mule Mocktail",
    "url": "http://drhyman.com/blogs/content/cranberry-moscow-mule-mocktail-dec",
    "image": "//drhyman.com/cdn/shop/articles/cranmuleMK.jpg?v=1739243891&width=433",
  },
  {
    "title": "Chocolate Olive Oil Mousse with Candied Walnuts",
    "url": "http://drhyman.com/blogs/content/chocolate-olive-oil-mousse-with-candied-walnuts-1",
    "image": "//drhyman.com/cdn/shop/articles/budino_copy_520x500_520x500_b357e1df-1d45-402a-b176-be43e6238a98.webp?v=1734550187&width=433",
  },
  {
    "title": "Caesar Salad with Grilled Chicken",
    "url": "http://drhyman.com/blogs/content/caesar-salad-with-grilled-chicken",
    "image":
      "//drhyman.com/cdn/shop/articles/u9994618697_A_vibrant_Caesar_salad_with_bite-sized_torn_romaine_84bb419f-a8fd-4b09-8149-25632c57a6bb.png?v=1742985608&width=433",
  },  {
    "title": "Spicy Turkey & Avocado Lettuce Wraps",
    "url": "http://drhyman.com/blogs/content/spicy-turkey-avocado-lettuce-wraps",
    "image":
      "//drhyman.com/cdn/shop/articles/09_turkeywraps.jpg?v=1742862245&width=433",
  },  {
    "title": "Garlic Shrimp with Sautéed Greens",
    "url": "http://drhyman.com/blogs/content/garlic-shrimp-with-sauteed-greens-cauliflower-rice",
    "image":
      "//drhyman.com/cdn/shop/articles/06_garlicshrimp.jpg?v=1742226900&width=433",
  },  {
    "title": "Easy Crockpot Shredded Chicken",
    "url": "http://drhyman.com/blogs/content/easy-crockpot-shredded-chicken",
    "image":
      "//drhyman.com/cdn/shop/articles/chxxrock.png?v=1741620186&width=433",
  },  {
    "title": "Lemon Raspberry Muffin",
    "url": "http://drhyman.com/blogs/content/lemon-raspberry-muffin",
    "image":
      "//drhyman.com/cdn/shop/articles/u9994618697_A_batch_of_warm_golden-brown_rasberry_muffins_with__9ec805a8-9d5d-421c-ae08-ba82d0d1e5b5.png?v=1741037694&width=433",
  },  {
    "title": "Baked Salmon Cakes",
    "url": "http://drhyman.com/blogs/content/baked-salmon-cakes",
    "image":
      "//drhyman.com/cdn/shop/articles/u9994618697_Two_large_golden_brown_lightly_crispy_salmon_cake_a72680bb-8086-4f1f-a7b5-9a13b61d137d_2.png?v=1740431989&width=433",
  },  {
    "title": "Southwest Salad",
    "url": "http://drhyman.com/blogs/content/southwest-salad",
    "image":
      "//drhyman.com/cdn/shop/articles/swsalad_6305bbe7-83b6-4628-8d59-20a125e5182c.jpg?v=1739833895&width=433",
  },  {
    "title": "Shrimp & Broccoli with Lemon",
    "url": "http://drhyman.com/blogs/content/shrimp-broccoli-with-lemon",
    "image":
      "//drhyman.com/cdn/shop/articles/u9994618697_broccoli_florets_large_peeled_and_deveined_shrimp_r_2114639c-2fcb-4089-b7dd-1c3a5babf127.png?v=1739243887&width=433",
  },  {
    "title": "Frittata with Spinach, Zucchini, Onion and Fresh Herbs",
    "url": "http://drhyman.com/blogs/content/frittata-with-spinach-zucchini-onion-and-fresh-herbs",
    "image":
      "//drhyman.com/cdn/shop/articles/frittata.png?v=1738108965&width=433",
  },  {
    "title": "Steak and Veggie Bowl",
    "url": "http://drhyman.com/blogs/content/steak-and-veggie-bowl",
    "image":
      "//drhyman.com/cdn/shop/articles/steak_salad_d2e79560-04bc-4246-bca3-5c154c5752c4.png?v=1738108820&width=433",
  },  {
    "title": "Lamb Meatballs with Tomato-Cucumber Salad and Cashew Yogurt",
    "url": "http://drhyman.com/blogs/content/lamb-meatballs-with-tomato-cucumber-salad-and-cashew-yogurt",
    "image":
      "//drhyman.com/cdn/shop/articles/lamb_meatballs_1_531f3cc8-935e-4752-95b4-f6a5b9df5cce.png?v=1739243890&width=433",
  },
];
